import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import userflow from 'userflow.js';

import { selectUserInfo } from '../store/selectors/auth';

const UserFlowManager = () => {
  const userInfo = useSelector(selectUserInfo);

  const { first_name, email } = userInfo?.sender || {};

  useEffect(() => {
    userflow.init(process.env.REACT_APP_USERFLOW_TOKEN || '');

    userflow.identify(userInfo?.user_id!, {
      name: first_name,
      email,
      signed_up_at: new Date().toISOString(),
    });
  }, [userInfo?.user_id, first_name, email]);

  return null;
};

export default UserFlowManager;
